<template>
    <div class="input-field" :class="{ 'no-label': !label }">
        <input
            :id="name"
            ref="input"
            :type="input_localType"
            :name="name"
            :class="[
                {
                    dirty: input_dirty,
                    hidden,
                    submitted,
                    'has-leading': $slots.leading,
                    'has-trailing': hasTrailing
                },
                inputClassList
            ]"
            :autofocus="autofocus"
            :required="required"
            :placeholder="placeholder"
            :maxlength="maxlength"
            :min="min"
            :max="max"
            :pattern="input_computedPattern"
            :value="input_localValue"
            :readonly="readonly"
            :step="step"
            :autocomplete="autocompleteValue"
            @input="input_updateInput(parseValue($event.target.value))"
            @focus="$emit('focus')"
            @blur="input_handleBlur"
            @select="input_handleSelect"
            @keydown="$emit('keydown', $event)"
            @keyup="$emit('keyup', $event)"
            @keydown.69="input_prevent"
        />

        <label v-if="label" :for="name">{{ label }}</label>

        <span v-if="showError" class="error-text">
            <slot name="error" />
        </span>

        <span v-if="$slots.help" class="assistive-text">
            <slot name="help" />
        </span>

        <div v-if="$slots.leading" class="leading">
            <!-- @slot Leading icon -->
            <slot name="leading" />
        </div>

        <div v-if="hasTrailing" class="trailing">
            <!-- @slot Trailing icon -->
            <slot name="trailing">
                <div class="toggle-password" @click="input_togglePassword">
                    <Icon :name="input_passwordIcon" />
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import inputMixin from '../../mixins/input';
import { Icon } from '../Icon';

import '../../assets/icons/eye-hide.svg';
import '../../assets/icons/eye-show.svg';

export default {
    name: 'DsInputField',

    components: {
        Icon,
    },

    mixins: [inputMixin],

    computed: {
        showError() {
            return Boolean(this.$slots.error && this.submitted);
        },

        autocompleteValue() {
            if (typeof this.autocomplete === 'boolean') {
                if (this.autocomplete) {
                    return 'on';
                }

                return 'off';
            }

            return this.autocomplete;
        },

        hasTrailing() {
            return this.$slots.trailing || this.type === 'password';
        },
    },

    methods: {
        parseValue(value) {
            return this.type === 'number' && value !== '' ? Number(value) : value;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../styles/common";

    .input-field {
        @include input-field;

        label {
            &.active {
                @include pill-label;
            }
        }

        input {
            @include input-text;
        }

        input.has-leading {
            @include padding-start($spacing-500);
        }

        input.has-trailing {
            @include padding-end($spacing-500);
        }

        input.has-leading:not(:focus):not(.dirty) + label {
            @include position-start($spacing-500);
        }

        .trailing {
            @include position-end($spacing-050);
            padding: $spacing-100;
            position: absolute;
            --icon-color: #{$color-ink-700};
        }

        .leading {
            @include position-start($spacing-050);
            padding: $spacing-100;
            position: absolute;
            --icon-color: #{$color-ink-700};
        }
    }

    .toggle-password {
        --icon-color: #{$color-ink-600};

        cursor: pointer;

        &:hover {
            --icon-color: #{$color-gray-900};
        }
    }
</style>
